import React, { useCallback, useEffect, useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import MyLocationIcon from '@mui/icons-material/MyLocation';

export const textBtnStyles = {
  paddingLeft: '0px !important',
  '&.MuiButtonBase-root:hover': {
    bgcolor: 'transparent',
  },
  alignSelf: 'flex-start',
};

const RepairFinderLocateBtn = ({ map }) => {
  const [loadingPosition, setLoadingPosition] = useState(false);

  const panToGeolocation = useCallback(async () => {
    setLoadingPosition(true);

    navigator.geolocation.getCurrentPosition((position) => {
      map.panTo({
        lat: parseFloat(position.coords.latitude),
        lng: parseFloat(position.coords.longitude),
      });
      setLoadingPosition(false);
      map.setZoom(11);
    }, () => setLoadingPosition(false));
  }, [map]);

  useEffect(() => {
    if (map) {
      panToGeolocation();
    }
  }, [map, panToGeolocation]);

  return (
    <Button
      onClick={panToGeolocation}
      variant="text"
      size="small"
      startIcon={loadingPosition ? <CircularProgress size={18} /> : <MyLocationIcon />}
      sx={textBtnStyles}
    >
      Use my current location
    </Button>
  );
};

export default RepairFinderLocateBtn;
